import { Injectable } from '@angular/core';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ChannelService {
  channels = [
    {
      id: 'salud',
      name: 'Salud',
      cover: '/assets/images/channels/salud.png',
    },
    /*{
      id: 'politica',
      name: 'Política',
      cover: '/assets/images/channels/politica.png',
    },*/
    {
      id: 'cultivo',
      name: 'Cultivo',
      cover: '/assets/images/channels/cultivo.png',
    },
    {
      id: 'gastronomia',
      name: 'Gastronomía',
      cover: '/assets/images/channels/gastronomia.png',
    },
    {
      id: 'recreativa',
      name: 'Recreativa',
      cover: '/assets/images/channels/recreativa.png',
    }
  ];

  getChannels() {
    return of(this.channels);
  }

  getChannelbyId(id: string) {
    return of(this.channels.find((item) => item.id == id));
  }
}
